module.exports = __webpack_public_path__ + "static/media/HK.bb078da1.svg";